import * as types from "../dashboardActionTypes";

const initialState = {
    incidents: [],
    summary: {}
};

export default function incidentsReducer(state = initialState, action) {
    switch(action.type) {
        case types.LOAD_INCIDENTS_SUCCESS:
            return action.incidents;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/incidentsReducer.js